import { effect, inject, Injectable, signal } from '@angular/core';
import { Kunde } from '@features/kunder/kunde.model';
import { KundeSearchParams } from '@features/kunder/kunde-search/kunde-search-params.model';
import { KundeDatasource } from '@features/kunder/kunde.datasource';

@Injectable({
  providedIn: 'root',
})
export class KunderService {
  datasource = inject(KundeDatasource);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  selectedKunde = signal<Kunde | undefined>(undefined);
  activeTab = signal('search');
  helbredsDato = signal<Date>(new Date());
  refreshDate = signal<Date>(new Date());

  searchKunde(searchParams: KundeSearchParams) {
    this.selectedKunde.set(undefined);
    this.datasource.searchParams.set(searchParams);
    this.datasource.loadData();
  }

  async selectKundeResultRow(kunde: Kunde) {
    await this.selectKunde(kunde);

    if (kunde) {
      this.activeTab.set('detail');
    }
  }

  async selectKunde(kunde: Kunde) {
    const k = await this.datasource.getById(kunde.id!);
    this.selectedKunde.set(k);
    this.helbredsDato.set(new Date());
    this.refreshDate.set(new Date());
  }

  async reSelectKunde() {
    await this.selectKunde(this.selectedKunde()!);
  }
}
